module.exports = __webpack_public_path__ + "img/play-phone.350a0aca.jpg";